import React, { useEffect, useState } from 'react';
import { startLoadingSpinner, stopLoadingSpinner } from '../../csf-ufc-pivotal/includes/utils';
import PivotalFormApi from "../../../js/csf/pivotal/PivotalFormApi";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";
import { findRemovedItems, resetErrMessages, updateHeadingBasedOnUrl } from '../includes/utils';
import PropTypes from "prop-types";
import { CsfPivotalFournisseurAddNotion } from './csf-fournisseur-recognition-request-add-notion';
import JustValidate from 'just-validate';
import CsfFournisseurRecognitionRenewalTitle
  from "../includes/csf-fournisseur-recognition-renewal-title";

export function FournisseurRecognitionRequestStepFourBlock({
  hasPreviousRenewalEndDate,
  accessToken,
  apiUrl,
  apiEnv,
  form,
  updateForm,
  currentStep,
  onStepChange,
  role,
  originalForm,
  updateOriginalForm,
  trainingId,
  activityCycleId
}) {

  const [notions, setNotions] = useState([]);
  const [selectedNotions, setSelectedNotions] = useState([]);
  const [originalSelectedNotions, setOriginalSelectedNotions] = useState([]);
  const [csfSubjects, setCsfSubjects] = useState([]);
  const [instituteSubjects, setInstituteSubjects] = useState([]);
  const [selectedSubjectId, setSelectedSubjectId] = useState('');
  const [displayChevron, setDisplayChevron] = useState(false);
  const [isPromoChecked, setIsPromoChecked] = useState(false);
  const [isCsfSubjectChanged, setIsCsfSubjectChanged] = useState(false);
  const language = document.documentElement.lang;
  const [displayTotalUFC, setDisplayTotalUFC] = useState(0);
  const [displayIQPFTotalUFC, setDisplayIQPFTotalUFC] = useState(0);
  const [displayBigTotalUFC, setDisplayBigTotalUFC] = useState(0);
  const [validator, setValidator] = useState(null);
  const [typeMatiere, setTypeMatiere] = useState('csf');
  const [displayTotalMin, setDisplayTotalMin] = useState(0);
  const [totalMin, setTotalMin] = useState(0);
  const [totalMinIQPF, setTotalMinIQPF] = useState(0);
  const [promoMin, setPromoMin] = useState(0);
  const [originalFormSubjects, setOriginalFormSubjects] = useState([]);
  const [chambreUFCValidation, setChambreUFCValidation] = useState(false);
  const [iqpfUFCValidation, setIqpfUFCValidation] = useState(false);

  const urlParams = new URLSearchParams(window.location.search);
  const isRenewal = (urlParams.get('renewal') === 'true' || hasPreviousRenewalEndDate);

  /*
* When the accessToken is fetched and state is updates, get the subjects
* */
  useEffect(() => {
    if (accessToken) {
      getSubjects();
    }
  }, [accessToken]);

  /*
  * Effect to remove to validation of UFC if here is on IQPF ufc.
  * */
  useEffect(() => {
    if (displayIQPFTotalUFC > 0 && iqpfUFCValidation === true) {
      setIqpfUFCValidation(false);
    }
  }, [displayIQPFTotalUFC]);

  /*
  * Effect to remove to validation of UFC if here is on Chambre ufc.
  * */
  useEffect(() => {
    if (displayTotalUFC > 0 && chambreUFCValidation === true) {
      setChambreUFCValidation(false);
    }
  }, [displayTotalUFC]);

  /*
  * Effect that check if csf subjects were changed.
  * */
  useEffect(() => {
    if (csfSubjects.length > 0 && instituteSubjects.length > 0 && !isCsfSubjectChanged) {
      setIsCsfSubjectChanged(true);
    }
  }, [csfSubjects, instituteSubjects]);

  /*
  * Effect that set the notions to the form is csf subject where changed.
  * */
  useEffect(() => {
    if (isCsfSubjectChanged === true) {
      setNotionsFromForm();
    }
  }, [isCsfSubjectChanged]);

  /*
  * Effect that display already saved data in component load
  * */
  useEffect(() => {
    getTotalUFCAsked();
    getTotalUFCAskedIQPF();
    setSelectedNotions(originalForm?.Notions__Secondary);
    setOriginalSelectedNotions(originalForm?.Notions__Secondary);
    setIsPromoChecked(form?.Total_Promotion_Time && form?.Total_Promotion_Time != "" ? true : false);
    getTotalMin();
    getTotalMinIQPF();
  }, [originalForm]);

  /*
  * Effect that display the promotion time
  * */
  useEffect(() => {
    getPromotionTime();
    setOriginalFormSubjects(form?.Cycle_UFC__Secondary);
  }, [form]);


  /*
  * Effect that change the big total of UFC wether the CSF UFCs or Iqpf UFCs is changed
  * */
  useEffect(() => {
    setDisplayBigTotalUFC(displayIQPFTotalUFC + displayTotalUFC);
  }, [displayIQPFTotalUFC, displayTotalUFC]);

  /*
  * Function that handle the next button to go to step 4
  * */
  function handleNextStepClick() {
    let nb = 1;
    if (role !== 1) { // if the user is not a concepteur, we dont want to show the draft screen
      // next step is 5 (formateurs) as specified in https://jira.tink.ca/browse/T5537-3474
      nb = 2;
    }
    onStepChange(currentStep + nb); // Call the callback function with new count
  }

  /*
  * Function that handle the back button to go to step 3
  * */
  function handlePreviousStepClick() {
    onStepChange(currentStep - 1); // Call the callback function with new count
  }

  function goToSpecificStep(step) {
    onStepChange(step); // Call the callback function with new count
  }

  /*
  * Function that add the notions to the right subject on components load
  * */
  function setNotionsFromForm() {
    const formSubjects = originalForm?.Notions__Secondary;
    let formattedSubjects = [];
    const uniqueSubjectIds = new Set();
    formSubjects?.forEach((subject) => {
      if (uniqueSubjectIds.has(subject.REDU_Subject_Id) && subject.REDU_Subject_Id !== null) {
        const existingSubjectIndex = formattedSubjects.findIndex(
          (formattedSubject) => formattedSubject.REDU_Subject_Id === subject.REDU_Subject_Id
        );

        if (existingSubjectIndex !== -1 && subject.REDU_Sub_Subject_Id !== null) {
          formattedSubjects[existingSubjectIndex].notions = formattedSubjects[existingSubjectIndex].notions || [];

          const uniqueSubSubjectIds = new Set(formattedSubjects[existingSubjectIndex].notions.map(item => item.REDU_Sub_Subject_Id));

          if (!uniqueSubSubjectIds.has(subject.REDU_Sub_Subject_Id)) {
            formattedSubjects[existingSubjectIndex].notions.push({
              Notion_English_Name: subject.Notion_English_Name,
              Notion_French_Name: subject.Notion_French_Name,
              REDU_Act__Sub_Subject_Id: subject.REDU_Act__Sub_Subject_Id,
              REDU_Sub_Subject_Id: subject.REDU_Sub_Subject_Id,
              REDU_Subject_Id: subject.REDU_Subject_Id,
              Subject_Name_English: subject.Subject_Name_English,
              Subject_Name_French: subject.Subject_Name_French,
              Sub_Subject_Name: subject.Sub_Subject_Name,
              EP_Appartenance: subject.EP_Appartenance,
              REDU_Sub_Subject_Id__Rn_Descriptor: subject.REDU_Sub_Subject_Id__Rn_Descriptor,
            });
          }
        }
      } else {
        uniqueSubjectIds.add(subject.REDU_Subject_Id);
        subject.notions = [];
        subject.notions.push({
          Notion_English_Name: subject.Notion_English_Name,
          Notion_French_Name: subject.Notion_French_Name,
          REDU_Act__Sub_Subject_Id: subject.REDU_Act__Sub_Subject_Id,
          REDU_Sub_Subject_Id: subject.REDU_Sub_Subject_Id,
          REDU_Subject_Id: subject.REDU_Subject_Id,
          Subject_Name_English: subject.Subject_Name_English,
          Subject_Name_French: subject.Subject_Name_French,
          Sub_Subject_Name: subject.Sub_Subject_Name,
          EP_Appartenance: subject.EP_Appartenance,
          REDU_Sub_Subject_Id__Rn_Descriptor: subject.REDU_Sub_Subject_Id__Rn_Descriptor,
        });
        formattedSubjects.push(subject);
      }
    });

    formattedSubjects.map((subject) => {
      if (subject.EP_Appartenance === 0) {
        addNotionsToSubject(subject?.notions, subject?.REDU_Subject_Id);
      } else {
        addNotionsToSubjectIQPF(subject?.notions, subject?.REDU_Subject_Id);
      }
    });
  }

  /*
  * Function that format the sujects object into a custom object with proper key.
  * */
  function formatSubjects(subjects, data) {
    let formattedSubjects = subjects.flatMap((subject) => {
      if ((data.get(subject.REDU_Subject_Id + "_min") !== "" || data.get(subject.REDU_Subject_Id + "_ufc") !== "") || subject.REDU_Cycle__Subject_Id !== "") {
        return {
          REDU_Cycle__Subject_Id: [""],
          REDU_Sub_Subject_Id: '',
          Subject_Id: subject?.REDU_Subject_Id,
          Duration_Time: data.get(subject.REDU_Subject_Id + "_min"),
          Asked_UFC: data.get(subject.REDU_Subject_Id + "_ufc"),
        };
      }
    });

    return addReduCycleSubjectIdToSubjects(formattedSubjects.filter(subject => subject));
  }

  /*
  * Function that add the Sycle SubjectID to the subject id.
  * */
  function addReduCycleSubjectIdToSubjects(subjects) {
    return subjects.flatMap((subject) => {
      form?.Cycle_UFC__Secondary.forEach((formSubject) => {

        if (subject.Subject_Id === formSubject?.Subject_Id) {
          subject.REDU_Cycle__Subject_Id = formSubject.REDU_Cycle__Subject_Id;
        }
      });

      return subject;
    });
  }

  /*
  * Effect that handle the step 4 validations
  * */
  useEffect(() => {
    const validator = new JustValidate('#form-step04');
    validator
      .addField('#total-mins', [
        {
          rule: 'required',
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
        },
        {
          rule: 'minNumber',
          value: 1,
          errorMessage: window.Drupal.t('fournisseur.creation_form.validation.minutes'),
        },
      ])

    const minutesInputs = document.querySelectorAll('.input-subject-time:not(:disabled):not(:read-only)');
    if (minutesInputs.length > 0 && !isRenewal) {
      minutesInputs.forEach((input) => {
        const relatedUFC = input.closest('.product-list-form').querySelector('.input-subject-ufc');
        let minimumMinutes = 60;
        if (relatedUFC) {
          minimumMinutes = 60 * (parseInt(relatedUFC.value) || 0);
        }
        const inputId = '#' + input.id;
        validator.addField(inputId, [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.timeMin'),
          },
          {
            rule: 'integer',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.integer'),
          },
          {
            rule: 'minNumber',
            value: minimumMinutes,
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.timeMin'),
          },
        ])
      })
    }

    const ufcInputs = document.querySelectorAll('.input-subject-ufc:not(:disabled):not(:read-only)');
    if (ufcInputs.length > 0 && !isRenewal) {
      ufcInputs.forEach((input) => {
        const inputId = '#' + input.id;
        validator.addField(inputId, [
          {
            rule: 'required',
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.required'),
          },
          {
            rule: 'minNumber',
            value: 1,
            errorMessage: window.Drupal.t('fournisseur.creation_form.validation.integer'),
          },
        ])
      })
    }

    if (isPromoChecked !== true && validator.fields) {
      validator.removeField('#total-mins');
    }

    setValidator(validator);
  }, [isPromoChecked, csfSubjects, displayBigTotalUFC]);

  /*
  * Main function that handle the step 4 submit process.
  * */
  function submitFormStep4(event) {
    event.preventDefault();

    let iqpfUFCValid = true;

    if (displayIQPFTotalUFC <= 0 && originalForm.Submitted_To_Financial_Instit === true && instituteSubjects?.length > 0) {
      iqpfUFCValid = false;
      setIqpfUFCValidation(true);
    }

    let chambreUFCValid = true;
    if (displayTotalUFC <= 0 && csfSubjects?.length > 0) {
      chambreUFCValid = false;
      setChambreUFCValidation(true);
    }

    const formElement = document.getElementById('form-step04');
    const data = new FormData(formElement);
    let formattedSubjects = formatSubjects(csfSubjects, data);
    formattedSubjects = [
      ...formattedSubjects,
      ...formatSubjects(instituteSubjects, data),
    ];

    // filter the formattedSubjects to remove the empty values.
    const formattedSubjectsFiltered = formattedSubjects.filter(item => (item.Duration_Time !== null && item.Duration_Time !== '') && (item.Asked_UFC !== null && item.Asked_UFC !== ''));
    const removeSubjects = findRemovedItems(originalFormSubjects, formattedSubjectsFiltered, 'subject');
    const formStep4 = {
      Activity_Id: originalForm?.REDU_Activity_Id,
      Total_Promotion_Time: data.get('total-mins'),
      GSFT_UFC_Total: displayBigTotalUFC,
      Duration: displayTotalMin,
      REDU_Cycle__Subject__Secondary: formattedSubjectsFiltered
    };

    if (isPromoChecked === false) {
      formStep4.Total_Promotion_Time = null;
    }

    const requestData = {
      form: 'CSF_EP_UXRecognition_4_REST',
      recordId: activityCycleId,
      deltadata: formStep4
    };

    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);

    if (validator) {
      validator.validate();
      setTimeout(() => {
        if (validator?.isValid && ((iqpfUFCValid === true && chambreUFCValid === true) || isRenewal)) {
          resetErrMessages();
          const removedItems = findRemovedItems(originalSelectedNotions, selectedNotions, 'notions');
          if (removedItems.length > 0) {
            deleteNotions(removedItems);
          }
          if (removeSubjects.length > 0) {
            deleteSubjects(removeSubjects);
          }
          startLoadingSpinner();
          pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
            .then(response => {
              if (response?.success && response?.payload?.data?.primary != null) {
                stopLoadingSpinner();
                updateForm();
                updateNotions();

                handleNextStepClick();
              }
            })
            .catch(error => {
              stopLoadingSpinner();
              console.error(error);
            });
        } else {
          console.error('Form validation failed!');
        }
      });
    }
  }

  /*
  * Method that calculate the total number of min.
  * */
  function updateTotalMin() {
    let inputs = document.querySelectorAll('#form-step04 .matieres-csf .input-subject-time:not(:disabled)');
    let totalMin = 0;
    inputs.forEach(input => {
      totalMin += parseInt(input.value) || 0;
    })
    setTotalMin(totalMin);
  }

  /*
* Method that calculate the total number of min for IQPF section.
* */
  function updateTotalMinIQPF() {
    let inputs = document.querySelectorAll('#form-step04 .matiere-iqpf .input-subject-time:not(:disabled)');
    let totalMin = 0;
    inputs.forEach(input => {
      totalMin += parseInt(input.value) || 0;
    })
    setTotalMinIQPF(totalMin);
  }

  /*
  * Method that updates the promo minutes.
  * */
  function updatePromoMin(e) {
    setPromoMin(parseInt(e.target.value) || 0);
  }

  useEffect(() => {
    setDisplayTotalMin(promoMin + totalMin + totalMinIQPF);
  }, [promoMin, totalMin, totalMinIQPF]);

  useEffect(() => {
    if (isPromoChecked === false) {
      setPromoMin(0);
    } else {
      setPromoMin(form?.Total_Promotion_Time);
    }
  }, [isPromoChecked]);


  /*
  * Method that calculate the total number of UFC is set on the original form on step 4 load.
  * */
  function getTotalUFCAsked() {
    let askedUFC = 0;
    if (form.Cycle_UFC__Secondary && form.Cycle_UFC__Secondary.length > 0) {
      form.Cycle_UFC__Secondary.map((cycle) => {
        if (cycle.Asked_UFC !== null && cycle.Appartenance === 0) {
          askedUFC = (askedUFC + cycle.Asked_UFC);
        }
      });
    }

    setDisplayTotalUFC(askedUFC);
  }

  /*
  * Method that calculate the total number of UFC is set on the original form on step 4 load for IQPF.
  * */
  function getTotalUFCAskedIQPF() {
    let askedUFC = 0;
    if (form.Cycle_UFC__Secondary && form.Cycle_UFC__Secondary.length > 0) {
      form.Cycle_UFC__Secondary.map((cycle) => {
        if (cycle.Asked_UFC !== null && cycle.Appartenance === 1) {
          askedUFC = (askedUFC + cycle.Asked_UFC);
        }
      });
    }

    setDisplayIQPFTotalUFC(askedUFC);
  }

  /*
  * Method that calculate the total number of minutes is set on the original form on step 4 load.
  * */
  function getTotalMin() {
    let askedMin = 0;
    if (form.Cycle_UFC__Secondary && form.Cycle_UFC__Secondary.length > 0) {
      form.Cycle_UFC__Secondary.map((cycle) => {
        if (cycle.Duration_Time !== null && cycle.Appartenance === 0) {
          askedMin = (askedMin + cycle.Duration_Time);
        }
      });
    }
    setTotalMin(askedMin);
  }

  /*
* Method that calculate the total number of minutes is set on the original form on step 4 load for IQPF section.
* */
  function getTotalMinIQPF() {
    let askedMin = 0;
    if (form.Cycle_UFC__Secondary && form.Cycle_UFC__Secondary.length > 0) {
      form.Cycle_UFC__Secondary.map((cycle) => {
        if (cycle.Duration_Time !== null && cycle.Appartenance === 1) {
          askedMin = (askedMin + cycle.Duration_Time);
        }
      });
    }
    setTotalMinIQPF(askedMin);
  }


  /*
  * Method that on askedUFC input field changed, we updated the total number of asked UFC
  * */
  function updateAskedUFC(event) {
    let inputs = document.querySelectorAll('#form-step04 .matieres-csf .input-subject-ufc:not(:disabled)');
    let totalUFC = 0;
    inputs.forEach(input => {
      totalUFC += parseFloat(input.value) || 0;
    })
    setDisplayTotalUFC(totalUFC);
  }

  /*
  * Method that on askedUFC input field changed, we updated the total number of asked UFC for IQPF table
  * */
  function updateAskedIQPFUFC(event) {
    let inputs = document.querySelectorAll('#form-step04 .matiere-iqpf .input-subject-ufc:not(:disabled)');
    let totalUFC = 0;
    inputs.forEach(input => {
      totalUFC += parseFloat(input.value) || 0;
    })
    setDisplayIQPFTotalUFC(totalUFC);
  }

  /*
  * Method that call the API to save the selected notions
  * */
  function updateNotions() {
    let notions = Array.from(csfSubjects.flatMap((subject) => {

      if (subject?.notions?.length > 0) {
        return subject.notions.map((notion) => {
          return {
            REDU_Act__Sub_Subject_Id: notion.REDU_Act__Sub_Subject_Id ?? "",
            REDU_Subject_Id: subject?.REDU_Subject_Id,
            REDU_Sub_Subject_Id: notion?.REDU_Sub_Subject_Id,
          };
        });
      }
    })).filter(notion => notion);

    let notionsIQPF = Array.from(instituteSubjects.flatMap((subject) => {

      if (subject?.notions?.length > 0) {
        return subject.notions.map((notion) => {
          return {
            REDU_Act__Sub_Subject_Id: notion.REDU_Act__Sub_Subject_Id ?? "",
            REDU_Subject_Id: subject?.REDU_Subject_Id,
            REDU_Sub_Subject_Id: notion?.REDU_Sub_Subject_Id,
          };
        });
      }
    })).filter(notion => notion);

    const allNotions = notions.concat(notionsIQPF);
    const requestData = {
      form: 'CSF_EP_UX_Subject_4_REST',
      recordId: trainingId,
      deltaData: {
        Notions__Secondary: allNotions
      }
    };
    const pivotalFormApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
    pivotalFormApi.callFormPutEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.primary != null) {
          stopLoadingSpinner();
          updateOriginalForm();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Get all Notions by subject to show in notion modal
  * */
  function getNotionsBySubject(subjectId, type) {
    setTypeMatiere(type);
    const requestData = {
      search: 'CSF_EP_Sub_Subjects_REST',
      searchResultsList: 'CSF_EP_Sub_Subjects_SRL',
      ParameterValues: [subjectId],
    };

    const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);

    pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
      .then(response => {
        if (response?.success && response?.payload?.data?.rows?.length > 0) {
          setNotions(response.payload.data.rows);
          setSelectedSubjectId(subjectId);
          stopLoadingSpinner();
        } else {
          setNotions([]);
          setSelectedSubjectId(subjectId);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  }

  /*
  * Method that call the API to retreive all subjects (both iqpf and csf).
  * */
  function getSubjects() {
    for (let i = 0; i < 2; i++) {
      const requestData = {
        search: 'CSF_EP_Subjects_REST',
        searchResultsList: 'CSF_EP_Subjects_SRL',
        ParameterValues: [i.toString()],
      };

      const pivotalSearchApi = new PivotalSearchApi(apiUrl, apiEnv, accessToken);

      pivotalSearchApi.callSearchEndpoint(requestData, '_Espace_Partenaire')
        .then(response => {
          if (response?.success && response?.payload?.data?.rows?.length >= 0) {
            if (i === 0) {
              setCsfSubjects(response.payload.data.rows);
            } else {
              setInstituteSubjects(response.payload.data.rows);
            }

            stopLoadingSpinner();
          }
        })
        .catch(error => {
          stopLoadingSpinner();
          console.error(error);
        });
    }
  }

  /*
  * Toggle display for notions
  * */
  const handleToggle = (event) => {
    event.preventDefault();
    const container = event.currentTarget.closest('.product-list');
    container.classList.toggle('expanded');
  };

  /*
  * Add selected notions from modal under the proper subject/matiere for CSF
  * */
  const addNotionsToSubject = (notions, subjectId) => {
    const updatedSubjects = csfSubjects.map((subject, index) => {
      if (subject.REDU_Subject_Id === subjectId && notions !== undefined) {

        if (subject.notions !== undefined && subject.notions.length > 0) {
          const mergedNotions = subject.notions.map(subjectNotion => {
            const matchingNotion = notions.find(notion => notion.REDU_Sub_Subject_Id === subjectNotion.REDU_Sub_Subject_Id);
            if (matchingNotion) {
              return { ...subjectNotion, ...matchingNotion };
            } else {
              return null;
            }
          }).filter(notion => notion !== null);
          notions.forEach(notion => {
            if (!subject.notions.some(subjectNotion => notion.REDU_Sub_Subject_Id === subjectNotion.REDU_Sub_Subject_Id)) {
              mergedNotions.push(notion);
            }
          });

          subject.notions = mergedNotions;

        } else {
          subject.notions = notions;
        }

        return subject;
      }
      return subject;
    })

    if (updatedSubjects.length > 0) {
      setCsfSubjects(updatedSubjects);
    }
  };

  /*
  * Add selected notions from modal under the proper subject/matiere for IQPF
  * */
  const addNotionsToSubjectIQPF = (notions, subjectId) => {

    const updatedSubjects = instituteSubjects.map((subject, index) => {
      if (subject.REDU_Subject_Id === subjectId && notions !== undefined) {
        if (subject.notions !== undefined && subject.notions.length > 0) {
          const mergedNotions = subject.notions.map(subjectNotion => {
            const matchingNotion = notions.find(notion => notion.REDU_Sub_Subject_Id === subjectNotion.REDU_Sub_Subject_Id);
            if (matchingNotion) {
              return { ...subjectNotion, ...matchingNotion };
            } else {
              return null;
            }
          }).filter(notion => notion !== null);

          notions.forEach(notion => {
            if (!subject.notions.some(subjectNotion => notion.REDU_Sub_Subject_Id === subjectNotion.REDU_Sub_Subject_Id)) {
              mergedNotions.push(notion);
            }
          });

          subject.notions = mergedNotions;

        } else {
          subject.notions = notions;
        }

        return subject;
      }
      return subject;
    })
    if (updatedSubjects.length > 0) {
      setInstituteSubjects(updatedSubjects);
    }
  };

  /*
  * Method that call the api to remove already selected notions.
  * */
  function deleteNotions(removedItems) {
    removedItems.forEach(item => {
      if (item?.REDU_Act__Sub_Subject_Id) {
        const requestData = {
          form: 'CSF_EP_Subject_Delete',
          recordId: item?.REDU_Act__Sub_Subject_Id,
        }
        const pivotalSearchApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        pivotalSearchApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
          .then(response => {
            if (response?.success) {
              stopLoadingSpinner();
            }
          })
          .catch(error => {
            stopLoadingSpinner();
            console.error(error);
          });
      }
    });
  }

  /*
  * Method that call the api to remove already selected subjects.
  * */
  function deleteSubjects(removedItems) {
    removedItems.forEach(item => {
      if (item?.REDU_Cycle__Subject_Id) {
        const requestData = {
          form: 'CSF_EP_Matiere_Delete',
          recordId: item?.REDU_Cycle__Subject_Id,
        }
        const pivotalSearchApi = new PivotalFormApi(apiUrl, apiEnv, accessToken);
        pivotalSearchApi.callFormDeleteEndpoint(requestData, '_Espace_Partenaire')
          .then(response => {
            if (response?.success) {
            }
          })
          .catch(error => {
            console.error(error);
          });
      }
    });
  }

  /*
  * Handle for modal submit
  * */
  const handleModalAdd = (pickedNotions) => {
    const newArray = selectedNotions.concat(pickedNotions);
    setSelectedNotions(newArray)
  };

  /*
  * Handle the add or the deletation of the notions chips
  * */
  useEffect(() => {
    if (selectedNotions && selectedNotions.length > 0) {
      setSelectedSubjectId('');
      const groupedData = {};
      selectedNotions.forEach(obj => {
        const key = obj.REDU_Subject_Id;
        if (!groupedData[key]) {
          groupedData[key] = [];
        }
        groupedData[key].push(obj);
      });


      if (typeMatiere === 'csf') {
        csfSubjects.forEach((subject) => {
          addNotionsToSubject([], subject.REDU_Subject_Id);
        });

        const groupedArray = Object.values(groupedData);
        groupedArray.forEach((subject) => {
          addNotionsToSubject(subject, subject[0].REDU_Subject_Id);
        });
      } else {
        instituteSubjects.forEach((subject) => {
          addNotionsToSubjectIQPF([], subject.REDU_Subject_Id);
        });

        const groupedArray = Object.values(groupedData);
        groupedArray.forEach((subject) => {
          addNotionsToSubjectIQPF(subject, subject[0].REDU_Subject_Id);
        });
      }

      setDisplayChevron(true);
    }

    updateTotalNotions();
  }, [selectedNotions]);

  /*
  * Method that change the total if all notions are removed or add
  * */
  function updateTotalNotions() {
    setTimeout(() => {
      updateTotalMin();
      updateTotalMinIQPF();
      updateAskedUFC();
      updateAskedIQPFUFC();
    }, 500);
  }

  /*
  * Handle for chip/notion removal
  * */
  const handleChipRemoval = (notionId, subjectId, type) => {
    setSelectedSubjectId('');
    // Create an object from the selected items
    let groupedData = {};
    selectedNotions.forEach(obj => {
      const key = obj.REDU_Subject_Id;
      if (!groupedData[key]) {
        groupedData[key] = [];
      }
      groupedData[key].push(obj);
    });

    //recreate the selected object without the clicked chip
    const filteredObject = {};
    for (const subject in groupedData) {
      for (const notion in groupedData[subject]) {
        if (groupedData[subject][notion].REDU_Subject_Id !== subjectId) {
          filteredObject[subject] = groupedData[subject];
        } else if (groupedData[subject][notion].REDU_Sub_Subject_Id !== notionId) {
          if (!filteredObject[subject]) {
            filteredObject[subject] = [];
          }
          filteredObject[subject].push(groupedData[subject][notion]);
        }
      }
    }

    if (type === 'csf') {
      csfSubjects.forEach((subject) => {
        addNotionsToSubject([], subject.REDU_Subject_Id);
      });
      // Remove the chip visually
      const groupedArray = Object.values(filteredObject);
      groupedArray.forEach((subject) => {
        addNotionsToSubject(subject, subject[0].REDU_Subject_Id);
      });
    } else {
      instituteSubjects.forEach((subject) => {
        addNotionsToSubjectIQPF([], subject.REDU_Subject_Id);
      });
      // Remove the chip visually
      const groupedArray = Object.values(filteredObject);
      groupedArray.forEach((subject) => {
        addNotionsToSubjectIQPF(subject, subject[0].REDU_Subject_Id);
      });
    }

    // Update the selected array without the removed chip
    const newArray = selectedNotions.filter(item => item.REDU_Sub_Subject_Id !== notionId);
    setSelectedNotions(newArray);
  };

  /*
  * Method that return the full amout of duration time of the training on component load.
  * */
  function getDurationTime(subject) {
    let durationTime = undefined;

    if (form?.Cycle_UFC__Secondary !== undefined && form?.Cycle_UFC__Secondary?.length > 0) {
      form?.Cycle_UFC__Secondary.forEach((formSubject) => {
        if (subject.REDU_Subject_Id === formSubject.Subject_Id) {
          durationTime = formSubject.Duration_Time;
        }
      });
    }

    return durationTime;
  }

  /*
  * Method that return the number the promotion time on component load and handle the checkbox for promotion.
  * */
  function getPromotionTime() {
    if (form && form.Total_Promotion_Time && form.Total_Promotion_Time !== null) {
      setIsPromoChecked(true);
    } else {
      setIsPromoChecked(false);
    }
  }

  /*
  * Method that return the number of asked UFC for the CSF table on component load.
  * */
  function getAskedUfc(subject) {
    let askedUfc = undefined;
    if (form?.Cycle_UFC__Secondary !== undefined && form?.Cycle_UFC__Secondary.length > 0) {
      form?.Cycle_UFC__Secondary.forEach((formSubject) => {
        if (subject.REDU_Subject_Id === formSubject.Subject_Id) {
          askedUfc = formSubject.Asked_UFC;
        }
      });
    }

    return askedUfc;
  }

  /*
  * Method that return the number of asked UFC for the IQPF table on component load.
  * */
  function getAskedIQPFUfc(subject) {
    let askedUfc = undefined;
    if (form?.Cycle_UFC__Secondary !== undefined && form?.Cycle_UFC__Secondary.length > 0) {
      form?.Cycle_UFC__Secondary.forEach((formSubject) => {
        if (subject.REDU_Subject_Id === formSubject.Subject_Id) {
          askedUfc = formSubject.Asked_UFC;
        }
      });
    }

    return askedUfc;
  }


  /*
  * Handle for Modal subject filter
  * */
  function OnChangeModalSubject(event) {
    getNotionsBySubject(event.target.value, typeMatiere);
  }

  /*
  * Updates which notions are selected in the modal
  * */
  function updateCurrentNotions(array) {
    setSelectedNotions(array);
  }

  /*
  * prevent other character than numeric to be add in numeric field.
  * */
  function handleKeyDown(event) {
    const invalidKeys = ['e', 'E', '+', '-', '.'];
    const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];

    if (invalidKeys.includes(event.key) ||
      (!allowedKeys.includes(event.key) && isNaN(Number(event.key)))) {
      event.preventDefault();
    }
  }


  // Change page title H1 if renewal
  useEffect(() => {
    updateHeadingBasedOnUrl("step4", "renewal", window.Drupal.t('fournisseur.creation_form.page.title'), window.Drupal.t('fournisseur.creation_form.page.renew.title'), hasPreviousRenewalEndDate);
  }, [hasPreviousRenewalEndDate]);

  return (
    <main className="fournisseur recognition">

      <h1 id="step4">{window.Drupal.t('fournisseur.creation_form.page.title')}</h1>

      <CsfFournisseurRecognitionRenewalTitle
        isRenewal={isRenewal || hasPreviousRenewalEndDate}
        formData={originalForm} />

      <div className="content">

        <aside className="form-steps-legend">
          <ol>
            <li className="completed"><button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(1)}><span>{window.Drupal.t('fournisseur.creation_form.steps.step1')}</span></button></li>
            <li className="completed"><button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(2)}><span>{window.Drupal.t('fournisseur.creation_form.steps.step2')}</span></button></li>
            <li className="completed"><button className="form-steps-legend-button btn-link" onClick={() => goToSpecificStep(3)}><span>{window.Drupal.t('fournisseur.creation_form.steps.step3')}</span></button></li>
            <li className="active"><span>{window.Drupal.t('fournisseur.creation_form.steps.step4')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step5')}</span></li>
            <li><span>{window.Drupal.t('fournisseur.creation_form.steps.step6')}</span></li>
          </ol>
        </aside>

        <div className="form-steps-content">
          <form onSubmit={submitFormStep4} id="form-step04">
            <fieldset>
              <legend className="visually-hidden">{window.Drupal.t('fournisseur.creation_form.page.title')}</legend>

              <div className="row" style={{ paddingTop: "1rem" }}>
                <div className="col-12 col-lg-7">
                  <div className="form-group d-flex align-items-center">
                    <input type="checkbox" id="promo-chk" name="promo-chk" checked={isPromoChecked}
                      onChange={(event) => setIsPromoChecked(event.target.checked)} />
                    <label htmlFor="promo-chk">{window.Drupal.t('fournisseur.recognition.detail.chk_promotion')}</label>
                  </div>
                </div>
                <div className="col-12 col-lg-5">
                  <div className="form-group">
                    <label htmlFor="total-mins">{window.Drupal.t('fournisseur.creation_form.dedicated.time')}*</label>
                    <input type="number" onKeyDown={handleKeyDown} id="total-mins" name="total-mins" defaultValue={form?.Total_Promotion_Time}
                           readOnly={!isPromoChecked} onChange={updatePromoMin} />
                  </div>
                </div>
              </div>

              <div className="form-container matieres-csf">
                <div className="form-container-title">
                  <h3>{window.Drupal.t('fournisseur.recognition.detail.subjects.csf')}</h3>
                </div>

                <div className="form-container-desc">
                  {window.Drupal.t('fournisseur.creation_form.applicable.concepts')}
                </div>

                {/* Being title row  */}
                <div className="row product-list-titles">
                  <div className="col-12 col-md-6 product-list-primary">
                    {window.Drupal.t('fournisseur.gestion.table.header.name')}
                  </div>
                  <div className="col-12 col-md-6 product-list-secondary">
                    <div className="row product-list-form">
                      <div className="col-2 product-list-notions">
                      </div>
                      <div className="col-4">
                        <div className="form-group-nopad">
                          {window.Drupal.t('fournisseur.creation_form.minute.qty')}
                        </div>
                      </div>
                      <div className="col-4">
                        <div className="form-group-nopad">
                          {window.Drupal.t('fournisseur.creation_form.ufc.qty')}
                        </div>
                      </div>
                      <div className="col-2">
                      </div>
                    </div>
                  </div>
                </div>

                {/* Being row  */}
                {csfSubjects.map((subject) => (
                  <div key={`csf-${subject.REDU_Subject_Id}`} className={subject?.notions?.length > 0 ? 'row product-list product-has-notion' : 'row product-list'}>
                    <div className="col-12 col-md-6 product-list-primary">
                      {!isRenewal && (
                        <div className="product-list-btn">
                          <button className="button btn-filled" type="button" data-toggle="modal" data-target="#AddNotion"
                            onClick={() => getNotionsBySubject(subject.REDU_Subject_Id, 'csf')}>
                            <img src="/themes/custom/tink/dist/assets/icn-add.svg" alt="" />
                          </button>
                        </div>
                      )}
                      <div className="product-list-title">
                        {
                          language === 'fr' && subject.Name_French ? subject.Name_French :
                            language === 'en' && subject.Name_English ? subject.Name_English : ''
                        }
                      </div>
                    </div>
                    <div className="col-12 col-md-6 product-list-secondary">
                      <div className="row product-list-form align-items-start">
                        <div className="col-2 product-list-notions">
                          {subject?.notions?.length > 0 &&
                            subject.notions.length + ' ' + window.Drupal.t('fournisseur.form.step4.notion.label') +
                            (subject.notions.length > 1 ? 's' : '')
                          }
                        </div>
                        <div className="col-4">
                          <div className="form-group-nopad">
                            <input className="input-subject-time" onKeyDown={handleKeyDown} type="number" id={subject.REDU_Subject_Id.slice(0, -1) + "_min_csf"} name={subject.REDU_Subject_Id + "_min"}
                              defaultValue={getDurationTime(subject)} readOnly={!subject?.notions?.length > 0 || isRenewal} onChange={updateTotalMin} />
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group-nopad ufc-nb">
                            <input className="input-subject-ufc" onKeyDown={handleKeyDown} type="number" id={subject.REDU_Subject_Id.slice(0, -1) + "_ufc"} name={subject.REDU_Subject_Id + "_ufc"}
                              defaultValue={getAskedUfc(subject)} readOnly={!subject?.notions?.length > 0 || isRenewal} onChange={updateAskedUFC} />
                          </div>
                        </div>
                        <div className="col-2">
                          {subject?.notions?.length > 0 ?
                            <button onClick={handleToggle} className="btn-link">
                              <img className="img-arrow" src="/themes/custom/tink/dist/assets/chevron-left.svg"
                                alt="chevron" />
                            </button> : ""
                          }
                        </div>
                      </div>
                    </div>
                    <div className="product-list-notions-container col-12">
                      {
                        subject?.notions?.map((notion) => (
                          <button key={`notion-${notion.REDU_Sub_Subject_Id__Rn_Descriptor}`} type="button" name="clients" className="button btn-notions"
                            onClick={() => handleChipRemoval(notion.REDU_Sub_Subject_Id, notion.GSFT_REDU_Subject ? notion.GSFT_REDU_Subject : notion.REDU_Subject_Id, 'csf')}
                            disabled={isRenewal}>
                            <span>{language === 'fr' ? (
                              notion.EP_French_Name ? notion.EP_French_Name : notion.Notion_French_Name
                            ) : (
                              notion.EP_English_Name ? notion.EP_English_Name : notion.Notion_English_Name
                            )}</span>
                            {!isRenewal &&
                            <span className="btn-delete">
                              <img src="/themes/custom/tink/dist/assets/icn-delete.svg" alt="" />
                            </span>
                            }
                          </button>
                        ))
                      }
                    </div>
                  </div>
                ))}

                {chambreUFCValidation === true && !isRenewal &&
                  <div className="form-container-desc" style={{ color: 'rgb(184, 17, 17)' }}>
                    {window.Drupal.t('fournisseur.chambre.ufc.validation.error')}
                  </div>
                }

                <div className="row product-list-totals">
                  <div className="col-12 col-md-6"></div>
                  <div className="col-12 col-md-6">
                    <div className="row product-list-form align-items-start">
                      <div className="col-2">
                        Total:
                      </div>
                      <div className="col-4">
                        <strong>&nbsp;{totalMin} minute{totalMin > 1 ? 's' : ''}</strong>
                      </div>
                      <div className="col-4">
                        <strong>{displayTotalUFC} {window.Drupal.t('fournisseur.form.step4.asked.ufc.label')}{displayTotalUFC > 1 && language == "fr" ? 's' : ''}</strong>
                      </div>
                      <div className="col-2"></div>
                    </div>
                  </div>
                </div>
              </div>

              {(originalForm.Submitted_To_Financial_Instit === true && instituteSubjects?.length > 0) &&
                <div className="form-container matiere-iqpf">
                  <div className="form-container-title">
                    <h3>{window.Drupal.t('fournisseur.recognition.detail.subjects.iqpf')}</h3>
                  </div>

                  <div className="form-container-desc">
                    {window.Drupal.t('fournisseur.creation_form.applicable.concepts')}
                  </div>

                  {/* Being title row  */}
                  <div className="row product-list-titles">
                    <div className="col-12 col-md-6 product-list-primary">
                      {window.Drupal.t('fournisseur.gestion.table.header.name')}
                    </div>
                    <div className="col-12 col-md-6 product-list-secondary">
                      <div className="row product-list-form">
                        <div className="col-2 product-list-notions">
                        </div>
                        <div className="col-4">
                          <div className="form-group-nopad">
                            {window.Drupal.t('fournisseur.creation_form.minute.qty')}
                          </div>
                        </div>
                        <div className="col-4">
                          <div className="form-group-nopad">
                            {window.Drupal.t('fournisseur.creation_form.ufc.qty')}
                          </div>
                        </div>
                        <div className="col-2">
                        </div>
                      </div>
                    </div>
                  </div>

                  {instituteSubjects.map((subject) => (
                    <div key={`ipf-${subject.REDU_Subject_Id}`} className={subject?.notions?.length > 0 ? 'row product-list product-has-notion' : 'row product-list'}>
                      <div className="col-12 col-md-6 product-list-primary">
                        {!isRenewal && (
                          <div className="product-list-btn">
                            <button className="button btn-filled" type="button" data-toggle="modal" data-target="#AddNotion"
                              onClick={() => getNotionsBySubject(subject.REDU_Subject_Id, 'iqpf')}>
                              <img src="/themes/custom/tink/dist/assets/icn-add.svg" alt="" />
                            </button>
                          </div>
                        )}
                        <div className="product-list-title">
                          {
                            language === 'fr' && subject.Name_French ? subject.Name_French :
                              language === 'en' && subject.Name_English ? subject.Name_English : ''
                          }
                        </div>
                      </div>
                      <div className="col-12 col-md-6 product-list-secondary">
                        <div className="row product-list-form">
                          <div className="col-2 product-list-notions">
                            {subject?.notions?.length > 0 &&
                              subject.notions.length + ' ' + window.Drupal.t('fournisseur.form.step4.notion.label') +
                              (subject.notions.length > 1 ? 's' : '')
                            }
                          </div>
                          <div className="col-4">
                            <div className="form-group-nopad">
                              <input className="input-subject-time" onKeyDown={handleKeyDown} type="number" id={subject.REDU_Subject_Id.slice(0, -1) + "_min_iqpf"} name={subject.REDU_Subject_Id + "_min"}
                                defaultValue={getDurationTime(subject)} readOnly={!subject?.notions?.length > 0 || isRenewal} onChange={updateTotalMinIQPF} />
                            </div>
                          </div>
                          <div className="col-4">
                            <div className="form-group-nopad ufc-nb">
                              <input className="input-subject-ufc" onKeyDown={handleKeyDown} type="number" id={subject.REDU_Subject_Id.slice(0, -1) + "_ufc"} name={subject.REDU_Subject_Id + "_ufc"}
                                defaultValue={getAskedIQPFUfc(subject)} readOnly={!subject?.notions?.length > 0 || isRenewal} onChange={updateAskedIQPFUFC} />
                            </div>
                          </div>
                          <div className="col-2">
                            {subject?.notions?.length > 0 ?
                              <button onClick={handleToggle} className="btn-link">
                                <img className="img-arrow" src="/themes/custom/tink/dist/assets/chevron-left.svg"
                                  alt="chevron" />
                              </button> : ""

                            }
                          </div>
                        </div>
                      </div>
                      <div className="product-list-notions-container col-12">
                        {
                          subject?.notions?.map((notion) => (
                            <button key={`notion-${notion.REDU_Sub_Subject_Id__Rn_Descriptor}`} type="button" name="clients" className={`button btn-notions ${isRenewal && 'd-none'}`}
                              onClick={() => handleChipRemoval(notion.REDU_Sub_Subject_Id, notion.GSFT_REDU_Subject ? notion.GSFT_REDU_Subject : notion.REDU_Subject_Id, 'iqpf')}>
                              <span>{language === 'fr' ? (
                                notion.EP_French_Name ? notion.EP_French_Name : notion.Notion_French_Name
                              ) : (
                                notion.EP_English_Name ? notion.EP_English_Name : notion.Notion_English_Name
                              )}</span>
                              {!isRenewal &&
                              <span className="btn-delete">
                                <img src="/themes/custom/tink/dist/assets/icn-delete.svg" alt="" />
                              </span>
                              }
                            </button>
                          ))
                        }
                      </div>
                    </div>
                  ))}

                  {iqpfUFCValidation === true && !isRenewal &&
                    <div className="form-container-desc" style={{ color: 'rgb(184, 17, 17)' }}>
                      {window.Drupal.t('fournisseur.iqpf.ufc.validation.error')}
                    </div>
                  }

                  {/* Being bottom totals row  */}
                  <div className="row product-list-totals">
                    <div className="col-12 col-md-6"></div>
                    <div className="col-12 col-md-6">
                      <div className="row product-list-form align-items-start">
                        <div className="col-2">
                          Total:
                        </div>
                        <div className="col-4">
                          <strong>&nbsp;{totalMinIQPF} minute{totalMinIQPF > 1 ? 's' : ''}</strong>
                        </div>
                        <div className="col-4">
                          <strong>{displayIQPFTotalUFC} {window.Drupal.t('fournisseur.form.step4.asked.ufc.label')}{displayIQPFTotalUFC > 1 && language == "fr" ? 's' : ''}</strong>
                        </div>
                        <div className="col-2"></div>
                      </div>
                    </div>
                  </div>

                </div>
              }

              <span className="product-list-legend">{window.Drupal.t('fournisseur.creation_form.footnote')}</span>

              <div className="row action-buttons">
                <div className="col text-center">
                  <button className="button btn-outlined btn-larger" type="button" onClick={() => handlePreviousStepClick()}>
                    {window.Drupal.t('fournisseur.previous.btn')}
                  </button>
                </div>
                <div className="col text-center">
                  <button className="button btn-larger" type="submit">
                    {window.Drupal.t('fournisseur.next.btn')}
                  </button>
                </div>
              </div>

            </fieldset>
          </form>
        </div >
      </div >

      <CsfPivotalFournisseurAddNotion OnChangeModalSubject={OnChangeModalSubject} language={language}
        csfSubjects={csfSubjects} notions={notions} currentNotions={selectedNotions} instituteSubjects={instituteSubjects}
        subjectId={selectedSubjectId} handleModalAdd={handleModalAdd}
        updateCurrentNotions={updateCurrentNotions} typeMatiere={typeMatiere} />
    </main >
  );
}

FournisseurRecognitionRequestStepFourBlock.propTypes = {
  hasPreviousRenewalEndDate: PropTypes.bool,
  accessToken: PropTypes.string.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  updateForm: PropTypes.func.isRequired,
  role: PropTypes.number.isRequired,
  currentStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired,
  originalForm: PropTypes.object.isRequired,
  updateOriginalForm: PropTypes.func.isRequired,
  trainingId: PropTypes.string.isRequired,
  activityCycleId: PropTypes.string.isRequired
}
